import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import App from './App';
import client from './apollo-client';
import './styles/inkwell.css';

/**
 * Application Entry Point
 *
 * Wraps the app with ApolloProvider to enable GraphQL functionality
 * throughout the component tree
 */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);
